/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationDropdownContainer_story = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_story" | "UserBanPopoverContainer_story">;
    readonly " $refType": "ModerationDropdownContainer_story";
};
export type ModerationDropdownContainer_story$data = ModerationDropdownContainer_story;
export type ModerationDropdownContainer_story$key = {
    readonly " $data"?: ModerationDropdownContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationDropdownContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationDropdownContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerationActionsContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBanPopoverContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'db72d8e81425c689aa66ca47fa11d612';
export default node;
